import { FunctionComponent, useContext } from "react"
import { Col, Row } from "react-bootstrap"
import Container from "react-bootstrap/Container"
import { AppContext } from "../components/AppContext"
import DoorsCard from "../components/DoorsCard"
import KeycardDoorsCard from "../components/KeycardDoorsCard"
import OpenDoorCard from "../components/OpenDoorCard"
import PrivateComponent from "../components/PrivateComponent"
import RolesCard from "../components/RolesCard"
import SwipeRecordsCard from "../components/SwipeRecordsCard"
import TenantsCard from "../components/TenantsCard"
import { Group } from "../data/models.interface"

interface IHomePage {}
const HomePage: FunctionComponent<IHomePage> = () => {
	// make sure the user has at least one of the relevant access control groups
	const { groups } = useContext(AppContext)
	const hasAccess = groups?.some((group) =>
		[
			Group.AccessControl,
			Group.AccessControlManager,
			Group.AccessControlAdmin,
			Group.AccessControlRemoteAccess,
			Group.GlobalAdmin,
		].includes(group),
	)
	if (!hasAccess) {
		return (
			<Container>
				<h2 className="text-center mt-4">Hero Access Control</h2>
				<p className="text-center mt-4">
					You are not authorized to view this page. Please contact the system administrator.
				</p>
			</Container>
		)
	}
	//
	return (
		<Container>
			<h2 className="text-center mt-4">Hero Access Control</h2>
			<Row>
				<PrivateComponent
					groups={[Group.AccessControl, Group.AccessControlManager, Group.AccessControlAdmin, Group.GlobalAdmin]}>
					<Col xs={12} sm={6}>
						<TenantsCard />
					</Col>
				</PrivateComponent>
				<PrivateComponent
					groups={[Group.AccessControl, Group.AccessControlManager, Group.AccessControlAdmin, Group.GlobalAdmin]}>
					<Col xs={12} sm={6}>
						<KeycardDoorsCard />
					</Col>
				</PrivateComponent>
				<PrivateComponent
					groups={[Group.AccessControl, Group.AccessControlManager, Group.AccessControlAdmin, Group.GlobalAdmin]}>
					<Col xs={12} sm={6}>
						<SwipeRecordsCard />
					</Col>
				</PrivateComponent>
				<PrivateComponent
					groups={[
						Group.AccessControlRemoteAccess,
						Group.AccessControlManager,
						Group.AccessControlAdmin,
						Group.GlobalAdmin,
					]}>
					<Col xs={12} sm={6}>
						<OpenDoorCard />
					</Col>
				</PrivateComponent>
				<PrivateComponent groups={[Group.AccessControlManager, Group.AccessControlAdmin, Group.GlobalAdmin]}>
					<Col xs={12} sm={6}>
						<RolesCard />
					</Col>
				</PrivateComponent>
				<PrivateComponent groups={[Group.AccessControlAdmin, Group.GlobalAdmin]}>
					<Col xs={12} sm={6}>
						<DoorsCard />
					</Col>
				</PrivateComponent>
			</Row>
		</Container>
	)
}
export default HomePage
